<template>
  <div
    v-if="showModal"
    class="modal show w-100 d-flex"
    role="dialog"
    aria-labelledby="staticBackdropLiveLabel"
    style="background-color:rgba(0,0,0,0.3)"
  >
    <div
      class="modal-dialog w-100 my-auto"
      role="document"
      :style="`margin-left:${isToolBarOpen ? '250' : '80'}px`"
    >
      <router-view name="modal" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ClientModal',
  computed: {
    ...mapGetters({
      isToolBarOpen: 'ui/isToolBarOpen',
      showModal: 'ui/showModal',
    }),
  },
};
</script>

<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: unset;
  }
}
@media (max-width: 992px) {
  .modal-dialog {
    margin-left: unset!important;
    margin-right: unset!important;
  }
}
</style>
